<template>
    <IconConfigProvider size="18px" class="icon-config">
        <div id="app">
            <router-view></router-view>
        </div>
    </IconConfigProvider>
</template>

<script>
import { IconConfigProvider } from '@v2icons/utils';
import { mapState, mapMutations } from 'vuex';
export default {
    components: {
        IconConfigProvider
    },
    computed: {
        ...mapState(['themeColor'])
    },
    watch: {
        themeColor(newValue) {
            const app = document.getElementById('app');
            app.style.setProperty('--theme-color', newValue);
        }
    },
    methods: {
        ...mapMutations(['setTheme']),
    },
    mounted() {
        const app = document.getElementById('app');
        app.style.setProperty('--theme-color', this.themeColor);

        if (sessionStorage.getItem('store')) {
            let store = sessionStorage.getItem('store');
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(store)));
        }

        //在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener('beforeunload', () => {
            sessionStorage.setItem('store', JSON.stringify(this.$store.state));
        });
    }
};









</script>
<!--
.el-menu {
    background-color: var(--theme-color) !important;
}
-->
<style lang="scss">
@import './assets/css/main.css';
@import './assets/css/global.css';

#app {
    --theme-color: #3c8dbc;
}

.header {
    background-color: var(--theme-color);
    // background-color: red;
}

.login-wrap {
    background: var(--theme-color);
}

.el-menu {
    background-color: #222222;
}
.tags-li.active {
    border: 1px solid var(--theme-color);
    background-color: var(--theme-color);
}

.collapse-btn:hover {
    background: var(--theme-color);
}

//修改 el-table 固定列样式问题
.el-table {
    .el-table__fixed { // 左固定列
        height: auto !important;
        bottom: 18px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些
    }
    .el-table__fixed-right { // 右固定列
        height: 100% !important;
        bottom: 18px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些
    }
}
</style>
